import { useNavigate } from 'react-router-dom'
import { BackButton } from '../components/back-button'
import { MobileScreen } from '../components/mobile-screen'
import {
  PLAN_TYPE_NAME,
  PLAN_TYPE_ORDER,
  TIER_NAMES,
  tierToIndex,
  useMyVip,
  isVipUser,
  type PlanType,
} from '../_lib/vip-api'

export function VipPage() {
  const navigate = useNavigate()
  const { data: my, isLoading } = useMyVip(true)
  const segByType = (t: PlanType) => my?.active_segments.find((s) => s.plan_type === t)
  return (
    <MobileScreen>
      <main data-testid="eovep" className="flex flex-1 flex-col">
        {/* Header: 返回按钮 + 居中组[crown + 会员权益] + 44px 占位 */}
        <div className="flex items-center gap-3 px-6 pb-6 pt-[max(10px,env(safe-area-inset-top))]">
          <BackButton />
          <h1 className="flex flex-1 items-center justify-center gap-2 text-[22px] font-bold text-[#1A1A1A]">
            <span className="text-[24px] leading-none" style={{ color: '#DAA520' }}>👑</span>
            <span style={{ fontFamily: 'Bricolage Grotesque, sans-serif', fontWeight: 700, fontSize: 22 }}>会员权益</span>
          </h1>
          <div className="h-11 w-11" />
        </div>

        <div className="flex flex-col gap-2 px-6 pb-4">
          {isLoading
            ? PLAN_TYPE_ORDER.map((t) => (
                <div
                  key={t}
                  className="animate-pulse rounded-xl bg-[#F6F7F8] h-[42px]"
                />
              ))
            : PLAN_TYPE_ORDER.map((t) => {
                const seg = segByType(t)
                return (
                  <div
                    key={t}
                    data-testid={`eovep-seg-${t}`}
                    className="flex items-center justify-between rounded-xl bg-[#F6F7F8] px-4 py-3"
                  >
                    <span className="text-[13px] font-medium text-[#1A1A1A]">
                      {PLAN_TYPE_NAME[t]}{seg ? ` · ${TIER_NAMES[tierToIndex(seg.tier)]}` : ''}
                    </span>
                    <span className="text-[11px] text-[#9CA3AF]">
                      {seg ? `到期 ${seg.expires_at.slice(0, 10)}` : '未开通'}
                    </span>
                  </div>
                )
              })}
        </div>

        <div className="flex-1" />

        <div className="px-6 pb-[max(34px,env(safe-area-inset-bottom))] pt-3">
          <button
            data-testid="eovep-renew-btn"
            type="button"
            disabled={isLoading}
            onClick={() => navigate('/vip/buy')}
            className="h-12 w-full rounded-xl bg-[#19caad] text-base font-semibold text-white disabled:opacity-50"
          >
            {isVipUser(my) ? '立即续费' : '立即开通'}
          </button>
        </div>
      </main>
    </MobileScreen>
  )
}
